import SvgIcon from '../../components/svg-icon/component-lib.esm.js';
import { SvgIconProps } from '../../components/svg-icon/component-lib.esm2.js';

//
var script = {
  name: 'SpotifyIcon',
  props: SvgIconProps,
  components: {
    SvgIcon
  }
};
export { script as default };